<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
    <path
      d="M22.9154 6.25033V18.7503C22.9154 19.3232 22.7114 19.8137 22.3034 20.2217C21.8954 20.6297 21.4049 20.8337 20.832 20.8337H4.16536C3.59245 20.8337 3.102 20.6297 2.69401 20.2217C2.28602 19.8137 2.08203 19.3232 2.08203 18.7503V6.25033C2.08203 5.67741 2.28602 5.18696 2.69401 4.77897C3.102 4.37099 3.59245 4.16699 4.16536 4.16699H20.832C21.4049 4.16699 21.8954 4.37099 22.3034 4.77897C22.7114 5.18696 22.9154 5.67741 22.9154 6.25033ZM4.16536 8.33366H20.832V6.25033H4.16536V8.33366ZM4.16536 12.5003V18.7503H20.832V12.5003H4.16536Z"
      fill="currentColor"
    />
  </svg>
</template>
